import { render, staticRenderFns } from "./lisaa-ilmoitus.vue?vue&type=template&id=491e85c6&scoped=true&"
import script from "./lisaa-ilmoitus.vue?vue&type=script&lang=ts&"
export * from "./lisaa-ilmoitus.vue?vue&type=script&lang=ts&"
import style0 from "./lisaa-ilmoitus.vue?vue&type=style&index=0&id=491e85c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491e85c6",
  null
  
)

export default component.exports